export const SendPageView = (url: string, path: string) =>
    gtag('event', 'page_view', {
        page_location: url,
        page_path: path,
        send_to: process.env.REACT_APP_GA_ID,
    });

export const SendLoginEvent = (method: string): void => gtag('event', 'login', { method: method });

export const SetUserId = (userId: number): void =>
    gtag('config', process.env.REACT_APP_GA_ID, {
        user_id: userId.toString(),
    });
